import { render, staticRenderFns } from "./PlumbNodeSummary.vue?vue&type=template&id=56c57b4c&"
import script from "./PlumbNodeSummary.vue?vue&type=script&lang=ts&"
export * from "./PlumbNodeSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports